<template>
      <v-container fluid  class="grey lighten-5">

        <v-dialog v-model="printDialog" max-width="500px">

          <v-card>
            <v-card-title>
              <span class="headline">
                 <span style="font-weight:bold">Opcije ispisa</span>
              </span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                >

                  <v-row v-if="documentName === 'DeliveryNoteSales'">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                         <v-checkbox
                          dense 
                          v-model="printCustom"
                          :label="lang.PrintCustom"
                        ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="documentName === 'InvoiceSales'">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                         <v-checkbox
                            dense 
                            v-model="printID"
                            :label="lang.printItemID"
                          ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="documentName === 'InvoiceSales'">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                         <v-checkbox
                            dense 
                            v-model="printXML"
                            label="Print to XML"
                          ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="documentName === 'QuoteSales'">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                         <v-checkbox
                            dense 
                            v-model="noTotal"
                            :label="lang.noTotal"
                          ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                        <v-checkbox
                          dense 
                            v-model="hidePrice"
                            :label="langC.HidePrice"
                          ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="documentName !== 'ServiceNotes'">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                         <v-checkbox
                          dense
                          v-model="useMemo"
                          :label="langC.useMemo"
                        ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="documentName === 'ServiceNotes' && !serviceVehicle">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                         <v-checkbox
                            dense
                            v-model="smallPrint"
                            :label="langC.SmallPrint"
                          ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="documentName === 'ServiceNotes' && serviceVehicle">
                    <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                         <v-select
                            v-model="vehiclePrintSelect"
                            :items="vehiclePrintType"
                            item-text="text"
                            item-value="value"
                            label="Vrsta ispisa"
                            persistent-hint
                            return-object
                            single-line
                            clearable 
                          ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="printDia" class="mr-3 pa-0"> {{langC.Cancel}} </v-btn>
                    <v-btn color="success"  @click="documentprint" class="mr-1 pa-0">{{langC.Print}}</v-btn>  
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
 
          </v-card>
        </v-dialog>

        <v-row class="mt-2">
          <v-col sm="2">
            <h1>{{documentNameLoc}}</h1>
          </v-col>
          <v-col sm="5">
            <span v-if="this.$store.state.user.AccessLevel <= 3 && !locked">
                <v-btn color="primary" @click="documentEdit" class="mr-1 pa-0">
                  {{langC.Edit}}
                </v-btn>
            </span>
            <span v-if="this.$store.state.user.AccessLevel <= 5">
                <v-btn  color="primary" @click="documentCopy" class="mr-1 pa-0">
                  KOPI
                </v-btn>
            </span>
            <span v-if="this.$store.state.user.AccessLevel <= 3">
                <v-btn color="primary" @click="documentPrevious" class="mr-1 pa-0">
                 PRETH.
                </v-btn>
            </span>
            <span v-if="this.$store.state.user.AccessLevel <= 3">
                <v-btn color="primary" @click="warehouseState" class="mr-1 pa-0">
                  {{langC.Warehouse2}}
                </v-btn>
            </span>
            <span v-if="this.$store.state.user.AccessLevel == 1 && !locked">
                <v-btn text color="red" @click="documentDelete" class="mr-1">
                  {{langC.Delete}}
                </v-btn>
            </span>
 
          </v-col>
          <v-col sm="1"></v-col>
          <v-col sm="4">
              <v-btn color="green" @click="printDia" class="ma-1 pa-1">
                  {{langC.Print}}
              </v-btn>
              <span v-if="!locked">
                <v-btn v-if="documentName === 'InvoiceSales' && !notEracun" color="green" @click="confirmeRacun" class="ma-1 pa-1" :disabled="sendingEracun">
                  eRačun
              </v-btn>
              </span> 
              <span v-if="locked">
                <v-btn v-if="documentName === 'InvoiceSales'" color="green" @click="checkStatus" class="ma-1 pa-1">
                  Provjeri status
              </v-btn>
              </span>            
              <span v-if="this.$store.state.user.AccessLevel <= 5 && !locked">
                <v-btn color="green" @click="documentSave" class="ma-1 pa-1" :disabled="saving">
                   {{langC.Save}}
                </v-btn>
                <v-progress-circular v-if="this.saving"
                  indeterminate
                  color="green"
                ></v-progress-circular>
              </span>
              <v-btn color="green" @click="documentlist" class="ma-1 pa-1">
                  {{langC.Back}}
              </v-btn>
          </v-col>
          
        </v-row> 


        <div v-if="showDialog">
          <Dialog :header="header" :message="message" :dcolor="dcolor" />
        </div>

        <v-row no-gutters>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
            
          </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col
              sm="4"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
              <appDocumentViewCard1></appDocumentViewCard1>
              <DocumentViewCard6 v-if="locked"></DocumentViewCard6>
              </v-card>
            </v-col>

            <v-col  sm="4">
              <v-card
                class="pa-2"
                outlined
                tile
              >
               <appDocumentViewCard2 />
              </v-card>
              <DigitalDocShortList />
            </v-col>

            <v-col
              sm="4"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                <appDocumentViewCard3 v-if="!pricechange"></appDocumentViewCard3>
                <appDocumentViewCard5 v-if="pricechange"></appDocumentViewCard5>
              </v-card>
            </v-col>
          </v-row>

          <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            bottom
            :color="color"
            >
            {{ text }}
          </v-snackbar>

 
          <v-row no-gutters>
            <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2" v-if="showUpdateItems">
              <v-btn color="green" @click="updatePrices" class="pr-2 pl-2 pa-0">
                Zapiši nove cijene u artikle     
              </v-btn>
            </v-col>
            <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2" >
              <v-btn text color="green" @click="warehouseState" class="pr-2 pl-2 pa-0">
                Stanje skladišta    
              </v-btn>
            </v-col>
          </v-row>


          <div v-if="!this.pricechange">
            <app-document-detail-list13 :key="componentKey"></app-document-detail-list13>
          </div>
          <div v-if="this.pricechange">
            <DocumentPriceChangeCRUD></DocumentPriceChangeCRUD>
          </div>
          <app-document-print-sales ref="prnt" :useMemo="useMemo" :printID="printID" :noTotal="noTotal"></app-document-print-sales>
          <app-document-print-purchase ref="prntPls"></app-document-print-purchase>
          <document-print-sales-service ref="printVehicle" />
          <div v-if="this.statewhs">
              <v-row class="pt-2">
                  <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                    <appDocumentWarehouseState></appDocumentWarehouseState>
                </v-col>
              </v-row>
          </div>
          <div v-if="this.previous">
              <v-row class="pt-2">
                  <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
                    <appDocumentDetailListPrevious></appDocumentDetailListPrevious>
                </v-col>
              </v-row>
          </div>

         
          <div>
            <v-dialog
              v-model="eRacunDialog"
              persistent
              max-width="390"
            >
              <v-card>
                
                <v-app-bar :color="dcolor">
                  <v-toolbar-title> {{header}}</v-toolbar-title>
                </v-app-bar>

                <v-card-title class="text-h5">
                </v-card-title>

                <v-card-text>{{message}}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :color="dcolor"
                    
                    @click="reseteRacunDialog"
                  >
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

   </v-container>

</template>

<script>
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import eRacun from '@/services/eRacunService'
import PondiService from '@/services/PondiService'
import ItemService from '@/services/ItemService'
import DocumentViewCard1 from './DocumentViewCard1'
import DocumentViewCard2 from './DocumentViewCard2'
import DocumentViewCard3 from './DocumentViewCard3'
import DocumentViewCard5 from './DocumentViewCard5'
import DocumentViewCard6 from './DocumentViewCard6'
import DocumentDetaillist13 from './DocumentDetailList13'
import DocumentPrintSales from './DocumentPrintSales'
import DocumentPrintPurchase from './DocumentPrintPurchase'
import DocumentPrintSalesService from './DocumentPrintSalesService'
import DocumentDetailListPrevious from './DocumentDetailListPrevious'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import DocumentWarehouseState from './DocumentWarehouseState'
import DigitalDocShortList from '../DigitalDoc/DigitalDocShortList.vue'
import WarehouseService from '@/services/WarehouseService'
import DocumentPriceChangeCRUD from './DocumentPriceChangeCRUD'
import { newUpdates, testLastUpdate } from '../../services/TestLastUpdate'
import { defNeweRacun } from './documentHelper'
import dayjs from 'dayjs'
import eRacunService from '@/services/eRacunService'
import Dialog from '@/snippets/Dialog'
import { mapGetters } from 'vuex'
import { baseURL } from '@/services/config'
import axios from 'axios'
import merService from '@/services/merService'
import ConverterService from '@/services/ConverterService'

export default {
  name: 'documentview',
  data () {
    return {
      eRacunDialog: false,
      showDialog: false,
      dcolor: 'success',
      header: '',
      message: '',
      haveAlert: false,
      lang: {},
      langC: {},
      saving: false,
      msg: '',
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      typeAna : 1,
      hidePrice: false,
      smallPrint: false,
      useMemo: false,
      itemsState: [],
      itemsUpdate: [],
      itemUpdate: {},
      document: {
      },
      loctaskOpenDate: '',
      locCreatedAt: '',
      locUpdatedAt: '',
      loctaskForDate: '',
      loctaskClosedDate: '',
      loctaskAlarmDate: '',
      haveRight: 4,
      documentActivData: {},
      documentNameLoc: '',
      documentName: '',
      itemsLoc: [],
      locdocumentDate: '',
      docSide: 0,
      mainQuery2: {},
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: '',
        databaseDocID: 0,
        items: []
      },
      previous: false,
      statewhs: false, 
      suppcard: false,
      componentKey: 0,
      pricechange: false,
      printCustom: false,
      printID: false,
      serviceVehicle: false,
      vehiclePrintType: [],
      vehiclePrintSelect: '',
      noTotal: false,
      showUpdateItems: false,
      locked: false,
      printDialog: false,
      printXML: false,
      notEracun: false,
      noItems: true,
      sendingEracun: false,
      pdfsBase64: [],
      haveEinvoice:true
    }
  },
  async mounted () {
    try {
      if (this.$store.state.language === 'EN') {
        this.langC = commEn
        this.lang = langEn
      }
      if (this.$store.state.language === 'HR') {
        this.lang = langHr
        this.langC = commHr
      }
       if (this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P9' || this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P10') {
          this.haveEinvoice = false
        }
      if (this.$store.state.documentSide === 1 && ( this.$store.state.documentActiv === 'ReceiptPurchase' || this.$store.state.documentActiv === 'Inventory'  || this.$store.state.documentActiv === 'PriceChange' ) ) {
        this.showUpdateItems = true
      }
      this.$store.dispatch('setDialogState', false)
      this.$store.dispatch('settypePOSPrint', 0)
      this.vehiclePrintType.push(
        {text: 'Potvrda primitka POS', value: 'confirmPOS'},
        {text: 'Potvrda primitka A6', value: 'confirmA6', width: '90px'},
        {text: 'Potvrda primitka A5', value: 'confirmA5', width: '90px'},
        {text: 'Predračun POS', value: 'proformaPOS', width: '150px'},
        {text: 'Predračun A6', value: 'proformaA6', width: '150px'},
        {text: 'Predračun A5', value: 'proformaA5', width: '150px'},
        {text: 'Nalog za servisera POS', value: 'mechanicPOS', width: '150px'},
        {text: 'Nalog za servisera A6', value: 'mechanicA6', width: '150px'},
        {text: 'Nalog za servisera A5', value: 'mechanicA5', width: '150px'},
      )
      if (this.$store.state.documentid) {
      this.documentNameLoc = this.$store.state.documentActivLoc
      this.documentName = this.$store.state.documentActiv
      this.pricechange = this.documentName === 'PriceChange' ? true : false
      this.docSide = this.$store.state.documentSide ? this.$store.state.documentSide : 3
      this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.mainQuery.businessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2021
      this.$store.dispatch("setGroupid", null)
      //this.$store.dispatch("setPartnerid", this.$store.state.documentActivHead.partnerId ? parseInt(this.$store.state.documentActivHead.partnerId): null)

      this.itemsState = []
      if (this.$store.state.companyActiv.CompanyShowWarehouseState) {
        this.typeAna = 1
        this.itemsState = await WarehouseService.whstate(this.mainQuery.CompanyId, this.mainQuery.businessYear, 1)
        this.typeAna = 4
      }
       if (this.documentName === 'ServiceNotes') {
        if (this.$store.state.user && this.$store.state.user.vehicles && this.$store.state.user.vehicles === true) {
          this.serviceVehicle = true
        }
      }
      if (this.$store.state.documentActivHead && this.$store.state.documentActivHead.documentLocked === true) {
        this.locked = true
      }
       if (this.$store.state.documentActivHead && this.$store.state.documentActivHead.exportDoc === true) {
        this.notEracun = true
      }
      //console.log('DocumentView Monuted this.$store.state.documentActivHead ', this.$store.state.documentActivHead.partnerVATID )
    }
    } catch(err) {
      // eslint-disable-next-line
      console.log(err)
    }    
  },
  methods: {
    async printDia() {
      
      this.printDialog = !this.printDialog
    },
    reseteRacunDialog() {
      this.$store.dispatch('setDocumentActivHead', {})
      this.$store.dispatch('setDocumentActivItems', [])
      this.$router.push({
         name: 'document'
       })
    },
    forceRerender() {
      this.componentKey += 1;  
    },
    documentPrevious() {
      this.previous = !this.previous
    },
    warehouseState() {
      this.statewhs = !this.statewhs
    },
    getFileExtension(filename) {
      // 1. Find the last index of the dot
      const lastDotIndex = filename.lastIndexOf('.');

      // 2. If there's no dot, or the dot is at the very start (hidden file), return empty
      if (lastDotIndex === -1 || lastDotIndex === 0) {
        return "";
      }

      // 3. Slice from the dot to the end
      return filename.slice(lastDotIndex + 1);
    },
    async checkAttachments() {
      try {
        this.pdfsBase64.length = 0
       
        if (this.$store.state.documentActivPdfs && this.$store.state.documentActivPdfs.length > 0 ) {
          // check for attachments and it size
          if (this.$store.state.documentActivPdfs.length > 3) {
            this.dcolor = 'error'
            this.header = ' Error!'
            this.message = 'Ne mogu se poslati više od 3 privitka! Max. number of attachment to send is 3!'
            this.showDialog = true
          }
          let errTxt = null

          let len = this.$store.state.documentActivPdfs.length;
          for (let i = 0; i < len; i++) {
            const query = {}
            query.path = this.$store.state.documentActivPdfs[i].path
            const res = await ConverterService.convertPdfToBase64(query)
            if (res && res.data && res.data.base64String) {
              this.pdfsBase64.push(res.data.base64String)
            }
          }
  

          // this.$store.state.documentActivPdfs.map(async(pdf) => {
          //   console.log('pretvaram  ', pdf.originalname)
          //   const fext = this.getFileExtension(pdf.originalname)
          //   if (fext !== 'pdf') {
          //     errTxt += 'Kriva datoteka ' + pdf.originalname + 'Nije pdf!'
          //   }
          //   const query = {}
          //   query.path = pdf.path
          //   const res = await ConverterService.convertPdfToBase64(query)
          //   if (res && res.data && res.data.base64String) {
          //     console.log('imam povrat  ', res.data.base64String.length)
          //     this.pdfsBase64.push(res.data.base64String)
          //   }
          // })

          console.log('imam privitke pretvorene u pdfs ', this.pdfsBase64.length)
          if (errTxt) {
            this.dcolor = 'error'
            this.header = ' Error!'
            this.message = errTxt
            this.showDialog = true
          }
       }
      } catch (error) {
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = error
        this.showDialog = true
      }
    },
    async confirmeRacun() {
      await this.documentSave()
      if ((this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P9' || this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P10') && this.$store.state.documentActivHead.documentTotalAmountToPay < 0) {
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Storno ili odobrenje NE MOŽE imati negativan iznos! Cancellation or approval CAN NOT be less then zero!'
        this.showDialog = true
        return
      }
      let sendit = false
      await this.checkAttachments()
      if (this.$store.state.documentActivItems && this.$store.state.documentActivItems.length > 0 ) {
        sendit = true
        this.$store.dispatch('setPrintType', {doBase64: true, posTypeA4Full: false})
        this.$store.dispatch('setPrintObj', {})
        await this.$refs.prnt.print()
        if (confirm('Da li ste sigurni da želite poslati eRačun? Confirm to send eInvoice?')) {
          this.sendingEracun = true
          await this.eRacunSend()
          this.sendingEracun = false
        }
      }
      if (!sendit) {
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Ne mmože se poslati račun bez stavka! Can not send invoice without items!'
        this.showDialog = true
      }
    },
    async eRacunPrintXML() {
      try {
        await this.checkAttachments()
        const doc = this.$store.state.documentActivHead
        doc.comp = this.$store.state.companyActiv
        doc.items = this.$store.state.documentActivItems
        doc.companyid = this.$store.state.companyid
        doc.businessYear = this.$store.state.businessYear
        doc.docBase64 = this.$store.state.printObj ? this.$store.state.printObj : ''
        doc.pdfsBase64 = this.pdfsBase64 && this.pdfsBase64.length > 0 ? this.pdfsBase64 : null     

        const res = this.haveEinvoice ? await eRacun.createubl(doc) :  await eRacun.createcreditnote(doc)
        
        if (res && res.data && res.data.zoveSe) {
          const zoveSe = res.data.zoveSe
          const newHead = {...this.$store.state.documentActivHead}
          newHead.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
          newHead.LastUpdate = new Date()
          newHead.eRacunXML = zoveSe
          const query = {
            eRacunXML: zoveSe
          }
  
          // const res2 = await axios({
          //   url: `${baseURL}/document/returnXMLfile`,
          //   params: query,
          //   method: 'GET',
          //   // CRITICAL: Tell axios to expect a binary file, not JSON
          //   responseType: 'blob', 
          //   // Include credentials if needed (e.g., cookies, session)
          //   // withCredentials: true, 
          //   headers: {
          //       // Include your authorization token if your server requires it
          //       'Authorization': `Bearer ${this.$store.state.token}`
          //     }
          //   });
          const res2 = await DocumentService.returnXMLfile(query)

            // 1. Create a URL for the blob (the downloaded file data)
          const fileURL = window.URL.createObjectURL(new Blob([res2.data]));

          // 2. Programmatically create a temporary anchor element
          const fileLink = document.createElement('a');

          // 3. Set the necessary attributes on the temporary link
          fileLink.href = fileURL;
          
          // This is the most crucial part for triggering the save dialog:
          // You generally get the filename from the server's Content-Disposition header.
          // For simplicity, we'll hardcode a fallback name here:
          let filename = zoveSe.split('/').pop();
          
          // **Optional Advanced Step: Extracting Filename from Headers**
          // A robust solution would extract the filename from the server's 'Content-Disposition' header:
          const disposition = res2.headers['content-disposition'];
          if (disposition && disposition.indexOf('attachment') !== -1) {
              const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, '');
              }
          }
          
          fileLink.setAttribute('download', filename); // Set the filename

          // 4. Append the link to the body, click it, and remove it
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);

          // 5. Revoke the temporary object URL
          window.URL.revokeObjectURL(fileURL);
        }
        console.log('nemam err ali nemam ni res')
      }
      catch(err) {
        console.log('err', err)
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Error on create XML invoice!. Greska kod kreiranja XML racuna!'
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async checkStatus() {
       if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 1) {
          await this.checkStatusPondi()
        }
        // mer
        if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {
           await this.checkStatusMER()
        }
    },
    async checkStatusPondi() {
      console.log('this.$store.state.companyActiv.eRacunProviderAPIkey ', this.$store.state.companyActiv.eRacunProviderAPIkey )
      try {
        const document = {
          docID: this.$store.state.documentActivHead.RespondedID,
          pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : ''
        } 
        const res = await PondiService.getstatusdok(document)
        if (res && res.data) {
          const rs = res.data
          if (this.$store.state.documentActivHead) {
            const newStatus = this.$store.state.pondiStatus.find(item => (item.value === rs.data.status))
            const newHead = {...this.$store.state.documentActivHead}
            newHead.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
            newHead.LastUpdate = rs.data.modifiedOn
            newHead.RespondedStatus = newStatus.badge
            newHead.RespondedReason = newStatus.text
            newHead.RespondedMessage = newStatus.text
            newHead.RespondedStatusColor = newStatus.color
            await DocumentService.put(newHead)           
            
            this.dcolor = 'green'
            this.header = ' Success! Uspjeh!'
            this.message = 'Novi status: ' + newStatus.text
            this.eRacunDialog = true
            
          } 
        }

      } catch (error) {
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Error on check document status. Greska kod provjere statusa dokumenta!' + error
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
      

    },
    async checkStatusMER() {

    },
    async eRacunSend() {
      try {

        if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 1) {
          if (this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P9' || this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P10')
          { await this.eracunCreateCreditNote() }
          if (this.$store.state.documentActivHead.eRacunPoslovniProcesSifra !== 'P9' && this.$store.state.documentActivHead.eRacunPoslovniProcesSifra !== 'P10')
          { await this.eracunCreate()}
        }
        // mer
        if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {
          if (this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P9' || this.$store.state.documentActivHead.eRacunPoslovniProcesSifra === 'P10') 
          { await this.eracunCreateMERcreditNote()}
          if (this.$store.state.documentActivHead.eRacunPoslovniProcesSifra !== 'P9' && this.$store.state.documentActivHead.eRacunPoslovniProcesSifra !== 'P10')
          { await this.eracunCreateMER()}
           
        }
      } catch (error) {
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Greska kod provjere status dokumenta. Error on check document status!'
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
       
    },
    async eracunCreate() {
      try {
        const doc = this.$store.state.documentActivHead

        doc.comp = this.$store.state.companyActiv
        doc.items = this.$store.state.documentActivItems
        doc.companyid = this.$store.state.companyid
        doc.businessYear = this.$store.state.businessYear
        doc.docBase64 = this.$store.state.printObj ? this.$store.state.printObj : ''
        doc.pdfsBase64 = this.pdfsBase64 && this.pdfsBase64.length > 0 ? this.pdfsBase64 : null

        let errorFree = false 
        const res = await eRacun.createubl(doc)
        if (res && res.data && res.data.xml) {
          const document = {
            doc: res.data.xml,
            pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : ''
          } 
          const zoveSe = res.data.zoveSe
          const res2 = await PondiService.testxml(document)
          if (res2 && res2.data && res2.data.restest && res2.data.restest.Errors) {
            const checkOne = res2.data.restest.Errors
 
            if (checkOne.length > 0) {
              let erText = 'Račun NIJE poslan! Greške: '
              checkOne.map(rr => {
                erText += " " + rr + '\n'
              })
              this.dcolor = 'error'
              this.header = ' Error!'
              this.message = erText
              this.showDialog = true
              this.$store.dispatch('setDialogState', true)
            }
            if (checkOne.length === 0) {
              // NEMA gresaka YESSSS
              errorFree = true
              console.log('NO ERROR!!! YEEEEESSSS', res2)
            }
            if (errorFree) {
              const res3 = await PondiService.sendxml(document)
              console.log('SEND eRACUN res3', res3)

              // res na servisu mer
              // ElectronicId: 3130016,
              // DocumentNr: '3/1/1',
              // DocumentTypeId: 1,
              // DocumentTypeName: 'Račun',
              // StatusId: 20,
              // StatusName: 'Obrađen',
              // RecipientBusinessNumber: '29524210204',
              // RecipientBusinessUnit: '',
              // RecipientBusinessName: 'A1 Hrvatska d.o.o.',
              // Created: '2025-12-16T11:32:18.150889+01:00',
              // Sent: '2025-12-16T11:32:18.2432144+01:00',
              // Modified: '2025-12-16T11:32:18.2432144+01:00',
              // Delivered: null


              // sad zapisem res3 u bazu eRacun i napravim locked racuna ..
              const neweRacun = defNeweRacun()
              neweRacun.RespondedID = res3.data.ressnd.id ? res3.data.ressnd.id : 0
              neweRacun.RespondedDate = res3.data.ressnd.insertedOn ? res3.data.ressnd.insertedOn : null
              neweRacun.RespondedMessage = res3.data.ressnd.message ? res3.data.ressnd.message : ''
              neweRacun.eRacunXML = zoveSe ? zoveSe : ''
              neweRacun.ID = 1
              //neweRacun.Status = 
              neweRacun.RespondedStatus = 'Poslan'
              neweRacun.onDate = dayjs(new Date()).format('YYYY-MM-DD')
              neweRacun.onTime = dayjs(new Date()).format('HH:mm')

              const res4 = await eRacunService.post(neweRacun)
              console.log('SAVED DATA ABOUT eRACUN to database', res4)
              if (this.$store.state.documentActivHead) {
                const newHead = {...this.$store.state.documentActivHead}
                newHead.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
                newHead.LastUpdate = new Date()
                newHead.documentLocked = true
                newHead.documentLockedDate = dayjs(new Date()).format('YYYY-MM-DD')
                newHead.documentLockedTime = dayjs(new Date()).format('HH:mm')
                newHead.documentLockedBy = this.$store.state.user.email ? 'eRačun, ' + this.$store.state.user.email : ''
                newHead.RespondedID = neweRacun.RespondedID
                newHead.RespondedDate = neweRacun.RespondedDate
                newHead.RespondedMessage = neweRacun.RespondedMessage
                newHead.RespondedStatus = 'Poslan'
                newHead.RespondedReason = neweRacun.RespondedMessage
                newHead.eRacunXML = zoveSe

                await DocumentService.put(newHead)
                console.log('Document PUT locked ')               
               
                this.dcolor = 'green'
                this.header = ' Success! Uspjeh!'
                this.message = 'Document is send as eInvoice! Račun je poslan kao eRačun!'
                this.eRacunDialog = true
                
              } 
            }
          }
          console.log('errorFree', errorFree)
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(' tu imam gresku bilo koju ',err)
        
        let erText = ''
        if (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors.length > 0){
          err.response.data.errors.map(rr => {
            erText += " " + rr + '\n'
          })
        }
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = erText
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async eracunCreateCreditNote() {
      try {
        const doc = this.$store.state.documentActivHead

        doc.comp = this.$store.state.companyActiv
        doc.items = this.$store.state.documentActivItems
        doc.companyid = this.$store.state.companyid
        doc.businessYear = this.$store.state.businessYear
        doc.docBase64 = this.$store.state.printObj ? this.$store.state.printObj : ''
        doc.pdfsBase64 = this.pdfsBase64 && this.pdfsBase64.length > 0 ? this.pdfsBase64 : null

        console.log('saljem doc u backend CREDIT NOTE ', doc, this.pdfsBase64)

        let errorFree = false 
        const res = await eRacun.createcreditnote(doc)
        if (res && res.data && res.data.xml) {
          const document = {
            doc: res.data.xml,
            pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : ''
          } 
          const zoveSe = res.data.zoveSe
          const res2 = await PondiService.testxml(document)
          if (res2 && res2.data && res2.data.restest && res2.data.restest.Errors) {
            const checkOne = res2.data.restest.Errors
            console.log('CREDIT NOTE res2.data', res2.data)
            if (checkOne.length > 0) {
              let erText = 'Račun NIJE poslan! Greške: '
              checkOne.map(rr => {
                erText += " " + rr + '\n'
              })
              this.dcolor = 'error'
              this.header = ' Error!'
              this.message = erText
              this.showDialog = true
              this.$store.dispatch('setDialogState', true)
            }
            if (checkOne.length === 0) {
              // NEMA gresaka YESSSS
              errorFree = true
              console.log('NO ERROR!!! YEEEEESSSS', res2)
            }
            if (errorFree) {
              const res3 = await PondiService.sendxml(document)
              console.log('SEND eRACUN res3', res3)


              // res na servisu mer
              // ElectronicId: 3130016,
              // DocumentNr: '3/1/1',
              // DocumentTypeId: 1,
              // DocumentTypeName: 'Račun',
              // StatusId: 20,
              // StatusName: 'Obrađen',
              // RecipientBusinessNumber: '29524210204',
              // RecipientBusinessUnit: '',
              // RecipientBusinessName: 'A1 Hrvatska d.o.o.',
              // Created: '2025-12-16T11:32:18.150889+01:00',
              // Sent: '2025-12-16T11:32:18.2432144+01:00',
              // Modified: '2025-12-16T11:32:18.2432144+01:00',
              // Delivered: null


              // sad zapisem res3 u bazu eRacun i napravim locked racuna ..
              const neweRacun = defNeweRacun()
              neweRacun.RespondedID = res3.data.ressnd.id ? res3.data.ressnd.id : 0
              neweRacun.RespondedDate = res3.data.ressnd.insertedOn ? res3.data.ressnd.insertedOn : null
              neweRacun.RespondedMessage = res3.data.ressnd.message ? res3.data.ressnd.message : ''
              neweRacun.eRacunXML = zoveSe ? zoveSe : ''
              neweRacun.ID = 1
              //neweRacun.Status = 
              neweRacun.RespondedStatus = 'Poslan'
              neweRacun.onDate = dayjs(new Date()).format('YYYY-MM-DD')
              neweRacun.onTime = dayjs(new Date()).format('HH:mm')

              const res4 = await eRacunService.post(neweRacun)
              console.log('SAVED DATA ABOUT eRACUN to database', res4)
              if (this.$store.state.documentActivHead) {
                const newHead = {...this.$store.state.documentActivHead}
                newHead.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
                newHead.LastUpdate = new Date()
                newHead.documentLocked = true
                newHead.documentLockedDate = dayjs(new Date()).format('YYYY-MM-DD')
                newHead.documentLockedTime = dayjs(new Date()).format('HH:mm')
                newHead.documentLockedBy = this.$store.state.user.email ? 'eRačun, ' + this.$store.state.user.email : ''
                newHead.RespondedID = neweRacun.RespondedID
                newHead.RespondedDate = neweRacun.RespondedDate
                newHead.RespondedMessage = neweRacun.RespondedMessage
                newHead.RespondedStatus = 'Poslan'
                newHead.RespondedReason = neweRacun.RespondedMessage
                newHead.eRacunXML = zoveSe

                await DocumentService.put(newHead)
                console.log('Document PUT locked ')               
               
                this.dcolor = 'green'
                this.header = ' Success! Uspjeh!'
                this.message = 'Document is send as eInvoice! Račun je poslan kao eRačun!'
                this.eRacunDialog = true
                
              } 
            }
          }
          console.log('errorFree', errorFree)
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(' tu imam gresku bilo koju ',err)
        
        let erText = ''
        if (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors.length > 0){
          err.response.data.errors.map(rr => {
            erText += " " + rr + '\n'
          })
        }
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = erText
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async eracunCreateMER() {
      try {
        const doc = this.$store.state.documentActivHead

        doc.comp = this.$store.state.companyActiv
        doc.items = this.$store.state.documentActivItems
        doc.companyid = this.$store.state.companyid
        doc.businessYear = this.$store.state.businessYear
        doc.docBase64 = this.$store.state.printObj ? this.$store.state.printObj : ''

        let errorFree = false 
        const res = await eRacun.createubl(doc)
        if (res && res.data && res.data.xml) {
          const document = {
            doc: res.data.xml,
            user: this.$store.state.companyActiv.eRacunProviderUserName ? this.$store.state.companyActiv.eRacunProviderUserName : '',
            pass: this.$store.state.companyActiv.eRacunProviderUserPassword ? this.$store.state.companyActiv.eRacunProviderUserPassword : '',
            companyVATID: this.$store.state.companyActiv.CompanyVATID? this.$store.state.companyActiv.CompanyVATID: ''
          } 
          const zoveSe = res.data.zoveSe
          const res3 = await merService.sendxml(document)
          console.log('SEND eRACUN MER res3', res3)

              // res na servisu mer
              // ElectronicId: 3130016,
              // DocumentNr: '3/1/1',
              // DocumentTypeId: 1,
              // DocumentTypeName: 'Račun',
              // StatusId: 20,
              // StatusName: 'Obrađen',
              // RecipientBusinessNumber: '29524210204',
              // RecipientBusinessUnit: '',
              // RecipientBusinessName: 'A1 Hrvatska d.o.o.',
              // Created: '2025-12-16T11:32:18.150889+01:00',
              // Sent: '2025-12-16T11:32:18.2432144+01:00',
              // Modified: '2025-12-16T11:32:18.2432144+01:00',
              // Delivered: null
            let haveMerOK = false
            if (res3 && res3.data && res3.data.ressnd && res3.data.ressnd.ElectronicId ) {
              haveMerOK = true
              // sad zapisem res3 u bazu eRacun i napravim locked racuna ..
              const neweRacun = defNeweRacun()
              neweRacun.RespondedID = res3.data.ressnd.ElectronicId ? res3.data.ressnd.ElectronicId : 0
              neweRacun.RespondedDate = res3.data.ressnd.Created ? res3.data.ressnd.Created : null
              neweRacun.RespondedMessage = res3.data.ressnd.StatusName ? res3.data.ressnd.StatusName : ''
              neweRacun.eRacunXML = zoveSe ? zoveSe : ''
              neweRacun.ID = 1
              //neweRacun.Status = 
              neweRacun.RespondedStatus = 'Poslan'
              neweRacun.onDate = dayjs(new Date()).format('YYYY-MM-DD')
              neweRacun.onTime = dayjs(new Date()).format('HH:mm')

              const res4 = await eRacunService.post(neweRacun)
              console.log('SAVED DATA ABOUT eRACUN to database', res4)
              if (this.$store.state.documentActivHead) {
                const newHead = {...this.$store.state.documentActivHead}
                newHead.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
                newHead.LastUpdate = new Date()
                newHead.documentLocked = true
                newHead.documentLockedDate = dayjs(new Date()).format('YYYY-MM-DD')
                newHead.documentLockedTime = dayjs(new Date()).format('HH:mm')
                newHead.documentLockedBy = this.$store.state.user.email ? 'eRačun, ' + this.$store.state.user.email : ''
                newHead.RespondedID = neweRacun.RespondedID
                newHead.RespondedDate = neweRacun.RespondedDate
                newHead.RespondedMessage = neweRacun.RespondedMessage
                newHead.RespondedStatus = 'Poslan'
                newHead.RespondedReason = neweRacun.RespondedMessage
                newHead.eRacunXML = zoveSe

                await DocumentService.put(newHead)
                console.log('Document PUT locked ')               
               
                this.dcolor = 'green'
                this.header = ' Success! Uspjeh!'
                this.message = 'Document is send as eInvoice! Račun je poslan kao eRačun!'
                this.eRacunDialog = true
                
              } 
            }
            if (!haveMerOK) {
              this.dcolor = 'error'
              this.header = ' Error!'
              this.message = res3.data.ressnd
              this.showDialog = true
              this.$store.dispatch('setDialogState', true)
            }
        }  
        console.log('errorFree', errorFree)

        
      } catch (err) {
        // eslint-disable-next-line
        console.log(' tu imam gresku bilo koju ',err)
        
        let erText = ''
        if (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors.length > 0){
          err.response.data.errors.map(rr => {
            erText += " " + rr + '\n'
          })
        }
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = erText
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async eracunCreateMERcreditNote() {
      try {
        const doc = this.$store.state.documentActivHead

        doc.comp = this.$store.state.companyActiv
        doc.items = this.$store.state.documentActivItems
        doc.companyid = this.$store.state.companyid
        doc.businessYear = this.$store.state.businessYear
        doc.docBase64 = this.$store.state.printObj ? this.$store.state.printObj : ''

        let errorFree = false 
        const res = await eRacun.createcreditnote(doc)
        if (res && res.data && res.data.xml) {
          const document = {
            doc: res.data.xml,
            user: this.$store.state.companyActiv.eRacunProviderUserName ? this.$store.state.companyActiv.eRacunProviderUserName : '',
            pass: this.$store.state.companyActiv.eRacunProviderUserPassword ? this.$store.state.companyActiv.eRacunProviderUserPassword : '',
            companyVATID: this.$store.state.companyActiv.CompanyVATID? this.$store.state.companyActiv.CompanyVATID: ''
          } 
          const zoveSe = res.data.zoveSe
          const res3 = await merService.sendxml(document)
          console.log('SEND eRACUN MER credit note res3', res3)

              // res na servisu mer
              // ElectronicId: 3130016,
              // DocumentNr: '3/1/1',
              // DocumentTypeId: 1,
              // DocumentTypeName: 'Račun',
              // StatusId: 20,
              // StatusName: 'Obrađen',
              // RecipientBusinessNumber: '29524210204',
              // RecipientBusinessUnit: '',
              // RecipientBusinessName: 'A1 Hrvatska d.o.o.',
              // Created: '2025-12-16T11:32:18.150889+01:00',
              // Sent: '2025-12-16T11:32:18.2432144+01:00',
              // Modified: '2025-12-16T11:32:18.2432144+01:00',
              // Delivered: null

            let haveMerOK = false
            if (res3 && res3.data && res3.data.ressnd && res3.data.ressnd.ElectronicId ) {
              haveMerOK = true
              // sad zapisem res3 u bazu eRacun i napravim locked racuna ..
              const neweRacun = defNeweRacun()
              neweRacun.RespondedID = res3.data.ressnd.ElectronicId ? res3.data.ressnd.ElectronicId : 0
              neweRacun.RespondedDate = res3.data.ressnd.Created ? res3.data.ressnd.Created : null
              neweRacun.RespondedMessage = res3.data.ressnd.StatusName ? res3.data.ressnd.StatusName : ''
              neweRacun.eRacunXML = zoveSe ? zoveSe : ''
              neweRacun.ID = 1
              //neweRacun.Status = 
              neweRacun.RespondedStatus = 'Poslan'
              neweRacun.onDate = dayjs(new Date()).format('YYYY-MM-DD')
              neweRacun.onTime = dayjs(new Date()).format('HH:mm')

              const res4 = await eRacunService.post(neweRacun)
              console.log('SAVED DATA ABOUT eRACUN to database', res4)
              if (this.$store.state.documentActivHead) {
                const newHead = {...this.$store.state.documentActivHead}
                newHead.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
                newHead.LastUpdate = new Date()
                newHead.documentLocked = true
                newHead.documentLockedDate = dayjs(new Date()).format('YYYY-MM-DD')
                newHead.documentLockedTime = dayjs(new Date()).format('HH:mm')
                newHead.documentLockedBy = this.$store.state.user.email ? 'eRačun, ' + this.$store.state.user.email : ''
                newHead.RespondedID = neweRacun.RespondedID
                newHead.RespondedDate = neweRacun.RespondedDate
                newHead.RespondedMessage = neweRacun.RespondedMessage
                newHead.RespondedStatus = 'Poslan'
                newHead.RespondedReason = neweRacun.RespondedMessage
                newHead.eRacunXML = zoveSe

                await DocumentService.put(newHead)
                console.log('Document PUT locked ')               
               
                this.dcolor = 'green'
                this.header = ' Success! Uspjeh!'
                this.message = 'Document is send as eInvoice! Račun je poslan kao eRačun!'
                this.eRacunDialog = true
                
              }
            }
             if (!haveMerOK) {
              this.dcolor = 'error'
              this.header = ' Error!'
              this.message = res3.data.ressnd
              this.showDialog = true
              this.$store.dispatch('setDialogState', true)
            }
        }  
        console.log('errorFree', errorFree)
        
      } catch (err) {
        // eslint-disable-next-line
        console.log(' tu imam gresku bilo koju ',err)
        
        let erText = ''
        if (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors.length > 0){
          err.response.data.errors.map(rr => {
            erText += " " + rr + '\n'
          })
        }
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = erText
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async documentlist () {
      try {
        await this.documentSave()
        this.$store.dispatch('setDocumentActivHead', {})
        this.$store.dispatch('setDocumentActivItems', [])
        await this.$router.push({
          name: 'document'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async documentCopy () {
      try {
        await this.$router.push({
          name: 'documentcopy'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async documentDelete () {
      try {
        await this.$router.push({
          name: 'documentdelete'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async documentprint() {
      await this.documentSave()
      this.$store.dispatch('setPrintObj', {})
      this.$store.dispatch('setPrintType', {doBase64: false, posTypeA4Full: false})
      
      if (this.printXML) {
        this.$store.dispatch('setPrintObj', {})
        this.$store.dispatch('setPrintType', {doBase64: true, posTypeA4Full: false})
        await this.$refs.prnt.print()
        await this.eRacunPrintXML()
        this.printXML = false
        return
      }
      this.printDia()
      if (this.smallPrint) {
         await this.$store.dispatch('setprintSmall', true)
      } else {
         await this.$store.dispatch('setprintSmall', false)
      }
      if (this.hidePrice) {
        await this.$store.dispatch('setprintNoPrice', true)
      } else {
        await this.$store.dispatch('setprintNoPrice', false)
      }
      // if print service 
      if (this.documentName === 'ServiceNotes') {
        this.$store.dispatch('settypePOSPrint', 1)
      }
      // if print custom DeliveryNoteSales
      if (this.documentName === 'DeliveryNoteSales' && this.printCustom) {
        this.$store.dispatch('settypePOSPrint', 100)
      }
      if (!this.vehiclePrintSelect) {
        if (this.$store.state.documentSide === 1 || this.pricechange) {
          this.$refs.prntPls.print()
        }
        if (this.$store.state.documentSide === 2 || this.$store.state.documentSide === 3) {
          this.$refs.prnt.print()
        }
      }
      if (this.$store.state.documentActiv === 'ServiceNotes' && this.serviceVehicle && this.vehiclePrintSelect){
        if (this.vehiclePrintSelect) {
          this.$store.dispatch('settypePOSName', this.vehiclePrintSelect.value)
          this.$refs.printVehicle.print()
        }
      }
      
    },
    async documentEdit () {
      try {
        await this.documentSave()
        this.$store.dispatch('seteditItem', 1)
        if (this.$store.state.user && this.$store.state.user.vehicles && this.$store.state.user.vehicles === true && this.$store.state.documentActiv === 'ServiceNotes') {
          await this.$router.push({
            name: 'documentcreateservice'
          })
        } else {
          await this.$router.push({
            name: 'documentcreate'
          })
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async documentDetails () {
      try {
        this.documentActivData = this.document
        this.$store.dispatch('setDocumentActivData', this.documentActivData)
        this.$store.dispatch('seteditItem', 1)
        await this.$router.push({
          name: 'documentdetail'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async updatePrices() {
      try {
        if (this.$store.state.documentActivHead) {
          this.saving = true
          await this.documentSave()
          const part = this.$store.state.documentActivHead.partnerNameDatabase ? this.$store.state.documentActivHead.partnerNameDatabase : this.$store.state.documentActivHead.partnerName
          console.log('part', part)
          const itemsUpd = []
          if (this.$store.state.documentActivItems) {
            this.$store.state.documentActivItems.map(item => {
              let updateItem = {}
              let suppDesc = ''
              
              updateItem.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
              updateItem.itemID = item.itemID
              updateItem.ItemSupppartnerName = this.$store.state.documentActivHead.partnerNameDatabase ? this.$store.state.documentActivHead.partnerNameDatabase : 0
              updateItem.ItemSupppartnerVATID = this.$store.state.documentActivHead.partnerVATID ? this.$store.state.documentActivHead.partnerVATID : 0
              updateItem.ItemSuppDate = this.$store.state.documentActivHead.documentDate ? this.$store.state.documentActivHead.documentDate : 0
              updateItem.ItemSuppDoc = parseInt(this.$store.state.documentActivHead.documentId)? parseInt(this.$store.state.documentActivHead.documentId): 0
              updateItem.ItemSuppDate = this.$store.state.documentActivHead.documentDate ? this.$store.state.documentActivHead.documentDate : null
              updateItem.itemSuppPrice = item.itemSuppPrice ? item.itemSuppPrice : 0
              updateItem.itemSuppBasePrice = item.itemSuppBasePrice ? item.itemSuppBasePrice : 0
              updateItem.itemSuppDiscount = item.itemSuppDiscount ? item.itemSuppDiscount : 0                
              updateItem.itemMargin = item.itemMargin ? item.itemMargin : 0
              updateItem.itemMaxDiscount = item.itemMaxDiscount ? item.itemMaxDiscount : 0
              updateItem.itemPrice = item.itemPrice ? item.itemPrice : 0
              updateItem.itemVAT1Percentage = item.itemVAT1Percentage ? item.itemVAT1Percentage : 0
              updateItem.itemVAT1Amount = item.itemVAT1Amount ? item.itemVAT1Amount : 0
              updateItem.itemDirectDuty1 = item.itemDirectDuty1 ? item.itemDirectDuty1 : 0
              updateItem.itemDirectDuty1 = item.itemDirectDuty1 ? item.itemDirectDuty1 : 0
              updateItem.itemPriceWithVAT= item.itemPriceWithVAT ? item.itemPriceWithVAT : 0
              suppDesc = this.$store.state.documentActivHead.documentName ? this.$store.state.documentActivHead.documentName : ''
              suppDesc += ', ' + (parseInt(this.$store.state.documentActivHead.documentId) ?  parseInt(this.$store.state.documentActivHead.documentId) : '')
              suppDesc += ', ' + (this.$store.state.documentActivHead.documentDate ? dayjs(this.$store.state.documentActivHead.documentDate).format('DD.MM.YYYY') : '')
              suppDesc += ', ' + part
              updateItem.ItemSuppCode = suppDesc
              updateItem.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
              updateItem.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
              updateItem.LastUpdate = new Date().toJSON().split("T")[0]
              itemsUpd.push(updateItem)
            })
          }

          if (itemsUpd && itemsUpd.length > 0) {
            await ItemService.updateprices(itemsUpd).then(async(res) => {
            console.log(' update prices done ', res && res.data ? res.data : '')
            await newUpdates(1)
            await testLastUpdate()
            }
            )
          }
        }

      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async documentSave () {
      try {
        if (this.$store.state.documentActivHead) {
          this.saving = true
          const docID = this.$store.state.documentActivHead.id ? this.$store.state.documentActivHead.id : 0
          if (this.$store.state.documentActivHead) {
            const newHead = {...this.$store.state.documentActivHead}
            newHead.LastUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
            newHead.LastUpdate = new Date()
            //console.log('Document Save this.$store.state.documentActivHead.partnerVATID', this.$store.state.documentActivHead.partnerVATID, newHead)
            await DocumentService.put(newHead)
          }          
          
          let newItems = []
          const itemsUpd = []
          if (this.$store.state.documentActivItems) {
            this.$store.state.documentActivItems.map(item => {
              let newObject = JSON.parse(JSON.stringify(item))
              delete newObject.id
              newItems.push(newObject)
            })
          }
          // if delete all items from document
          if (newItems.length === 0 && docID > 0 ) {
            let newObject = {
              databaseDocID : docID
            }
            newItems.push(newObject)
          }

          if (newItems) {
            await DocumentDetailService.saveitems(newItems).then(res => {
              this.text = this.langC.DocumentSaved + (res && res.data && res.data.message ? res.data.message : '')
              this.color = 'green'
              this.snackbar = true
            }).catch(err => {
              this.text = this.langC.DocumentSaveError + (err.data)
              this.color = 'red'
              this.snackbar = true
            })
          }

          this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 1
          this.mainQuery.businessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2020
          this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
          this.mainQuery.databaseDocID = this.$store.state.databaseDocID ? this.$store.state.databaseDocID : null
          this.itemsLoc = []
          this.itemsLoc = (await DocumentDetailService.index(this.mainQuery)).data.documentDetails
          if (this.itemsLoc) {
            this.$store.dispatch('setDocumentActivItems', this.itemsLoc)
          } else {
            this.$store.dispatch('setDocumentActivItems', [])
          }
          this.forceRerender()
          this.saving = false
        }

      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  computed: {
    ...mapGetters({
      locDialog: 'NeedDialogState'
    })
  },
  watch: {
    'locDialog' () {
      this.showDialog = this.locDialog
    },
  },
  components: {
    appDocumentViewCard1: DocumentViewCard1,
    appDocumentViewCard2: DocumentViewCard2,
    appDocumentViewCard3: DocumentViewCard3,
    appDocumentViewCard5: DocumentViewCard5,
    appDocumentDetailList13: DocumentDetaillist13,
    appDocumentPrintSales: DocumentPrintSales,
    appDocumentPrintPurchase: DocumentPrintPurchase,
    appDocumentWarehouseState: DocumentWarehouseState,
    appDocumentDetailListPrevious: DocumentDetailListPrevious,
    DocumentPriceChangeCRUD,
    DigitalDocShortList,
    DocumentPrintSalesService,
    Dialog,
    DocumentViewCard6
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
